import { putApi } from "./api_instance";

export const updatedListedProjectCreditsApi = async (bidData, dispatch) => {
  try {
    return await putApi({
      apiUrl: "/projects/api/holdings/updateListedProject",
      dispatch,
      sendToken: true,
      data: bidData,
    });
  } catch (error) {
    throw error;
  }
};
